import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { ReadOnlyInput } from '@infoods/lifebase-ui';

import {
  LbCreatableAutocomplete,
  LbNumericFormatInput,
} from '../../../../../shared/components/form-components';
import { FoodBrand } from '../../../../interfaces/FoodBrand';
import { FoodFormValues } from '../../interfaces/FoodFormValues';
import { transformToOptions } from '../../../../../shared/utils/arrayUtils';

type SupplementFieldsProps = {
  brands: FoodBrand[];
};

const servingRange = {
  min: { value: 1, message: 'Value must be greater than or equal to 1!' },
  max: { value: 40000, message: 'Value must be less than or equal to 40 000!' },
};

const SupplementFields = ({ brands }: SupplementFieldsProps) => {
  const { control } = useFormContext<FoodFormValues>();
  const brandOptions = transformToOptions({
    list: brands,
    valueKey: 'name',
    labelKey: 'name',
  });

  const [servingSize, servingPerContainer, amountUnit] = useWatch({
    control,
    name: ['servingSize', 'servingPerContainer', 'amountUnit'],
  });

  const totalPerContainer =
    servingSize && servingPerContainer ? servingSize * servingPerContainer : null;

  return (
    <>
      <LbCreatableAutocomplete
        control={control}
        name="brand"
        label="Brand"
        options={brandOptions}
        prepareAddedOption={(name) => ({ value: name, label: name })}
      />
      <LbNumericFormatInput
        control={control}
        name="servingSize"
        label="Serving Size"
        rules={{
          ...servingRange,
        }}
        allowNegative={false}
        decimalScale={0}
        selectValueOnFocus
      />
      <LbNumericFormatInput
        control={control}
        name="servingPerContainer"
        label="Servings / Container"
        rules={{
          ...servingRange,
        }}
        allowNegative={false}
        decimalScale={0}
        selectValueOnFocus
      />
      <ReadOnlyInput
        control={control}
        name="totalPerContainer"
        label={`${amountUnit} / Container`}
        value={totalPerContainer}
        placeholder="—"
      />
    </>
  );
};

export { SupplementFields };
